import { render, staticRenderFns } from "./ModalCreateSeller.vue?vue&type=template&id=20e97df5"
import script from "./ModalCreateSeller.vue?vue&type=script&lang=js"
export * from "./ModalCreateSeller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports